import React from "react";
import PropTypes from "prop-types";

const RastreamentoPainel = ({
  items,
  selectedExam,
  selectedYear,
  selectedMonth,
  months,
  onSelectYear,
  onSelectMonth,
}) => {
  const safeItems = Array.isArray(items) ? items : [];
  const safeMonths = Array.isArray(months) ? months : [];

  return (
    <div className="card mb-3 convocacao-card-shell">
      <div className="card-body d-grid gap-4">
        {safeItems.map((group) => {
          const groupClass = group.exam === "Mama" ? "is-mama" : "is-colo";

          return (
            <div key={group.exam} className={`convocacao-painel-group ${groupClass}`}>
              <h5 className="mb-3">{group.title}</h5>
              <div className="row g-3">
                <div className="col-12 col-lg-3">
                  <div className="convocacao-summary-card h-100">
                    <div className="d-flex justify-content-between align-items-start gap-2">
                      <div>
                        <div className="small text-muted">Total de mulheres</div>
                        <div className="convocacao-summary-value">{group.totalMulheres}</div>
                      </div>
                      <span className="convocacao-card-icon" aria-hidden="true">
                        <i className="feather-user" />
                      </span>
                    </div>
                  </div>
                </div>
                {group.years.map((item) => {
                  const active = selectedExam === group.exam && selectedYear === item.year;
                  return (
                    <div className="col-12 col-lg-3" key={`${group.exam}-${item.year}`}>
                      <div
                        className={`convocacao-year-card h-100 ${active ? "is-active" : ""}`}
                        role="button"
                        tabIndex={0}
                        onClick={() => onSelectYear(group.exam, item.year)}
                        onKeyDown={(event) => {
                          if (event.key === "Enter" || event.key === " ") {
                            onSelectYear(group.exam, item.year);
                          }
                        }}
                      >
                        <div className="d-flex justify-content-between align-items-start gap-2">
                          <div>
                            <div className="small text-uppercase text-muted fw-semibold">ANO {item.year}</div>
                            <div className="convocacao-year-value">{item.total}</div>
                          </div>
                          <span className="convocacao-card-icon" aria-hidden="true">
                            <i className="feather-calendar" />
                          </span>
                        </div>
                        <div className="convocacao-month-row">
                          <span>mês</span>
                          <select
                            value={active ? selectedMonth || "" : ""}
                            onClick={(event) => event.stopPropagation()}
                            onChange={(event) =>
                              onSelectMonth(
                                group.exam,
                                item.year,
                                event.target.value ? Number(event.target.value) : null,
                              )
                            }
                          >
                            <option value="">Todos</option>
                            {safeMonths.map((month) => (
                              <option key={month.value} value={month.value}>
                                {month.label.slice(0, 3).toLowerCase()}
                              </option>
                            ))}
                          </select>
                        </div>
                        {active && group.totalMes !== null && (
                          <div className="small text-muted mt-2">
                            {group.mesLabel}: {group.totalMes} mulheres
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

RastreamentoPainel.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      exam: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      totalMulheres: PropTypes.number.isRequired,
      years: PropTypes.arrayOf(
        PropTypes.shape({
          year: PropTypes.number.isRequired,
          total: PropTypes.number.isRequired,
        }),
      ).isRequired,
    }),
  ).isRequired,
  selectedExam: PropTypes.string,
  selectedYear: PropTypes.number,
  selectedMonth: PropTypes.number,
  months: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onSelectYear: PropTypes.func.isRequired,
  onSelectMonth: PropTypes.func.isRequired,
};

RastreamentoPainel.defaultProps = {
  selectedExam: "TODOS",
  selectedYear: null,
  selectedMonth: null,
};

export default RastreamentoPainel;
